import { render } from "./OptionalModules.vue?vue&type=template&id=e4ad1e5c&scoped=true"
import script from "./OptionalModules.vue?vue&type=script&lang=js"
export * from "./OptionalModules.vue?vue&type=script&lang=js"

import "./OptionalModules.vue?vue&type=style&index=0&id=e4ad1e5c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ad1e5c"]])

export default __exports__